// import * as Sentry from "@sentry/browser";
// import { BrowserTracing } from "@sentry/tracing";
import ComponentHelper from './components/00_utilities/helpers/ComponentHelper';

const componentHelper = new ComponentHelper();

if (__devMode__) {
    __webpack_public_path__ = 'http://localhost:9000/wp-content/themes/newtron-rebrush/';
}

componentHelper.initializePage();

/**
 * @hneupert describe what this function does
 */
function removeAfterReload() {
    document.querySelector('body').classList.remove('body-remove-on-load');
}

window.$ = jQuery;

$(window).on('load', () => {
    setTimeout(removeAfterReload, 100);
});

/**
 * Check for hot module replacement and use it if possible
 */
if (module.hot) {
    module.hot.accept();
}

/**
 * https://docs.sentry.io/platforms/javascript/#configure
 */
// Sentry.init({
//     dsn: "https://b4cf2ad4b48b47d1b98920beac10516b@o132372.ingest.sentry.io/5530530",
//
//     // Alternatively, use `process.env.npm_package_version` for a dynamic release version
//     // if your build tool supports it.
//     release: "newtron-relaunch@1.0.0",
//     integrations: [new BrowserTracing()],
//
//     // Set tracesSampleRate to 1.0 to capture 100%
//     // of transactions for performance monitoring.
//     // We recommend adjusting this value in production
//     tracesSampleRate: 1.0,
// });
